<template>
  <a-layout id="components-layout-demo-side" style="min-height: 100vh">
    <a-layout-sider v-model="collapsed" collapsible>
      <div class="logo">
        <!--        云E宝运营管理系统-->
        <img alt="logo" class="logo" src="~@/assets/images/logo.png" />
      </div>
      <a-menu
        v-if="loadMenu"
        :default-selected-keys="selectKeys"
        :open-keys="openKeys"
        :selectedKeys="selectKeys"
        mode="inline"
        theme="dark"
        @click="menuClick"
        @openChange="onOpenChange"
      >
        <template v-for="item in routerList">
          <a-menu-item v-if="item.children.length === 0" :key="item.url" :name="item.name">
            <span>
              <i v-if="item.icon" class="anticon anticon-setting">
                <img :src="item.icon" class="sider_icon" />
              </i>
              <a-icon v-if="!item.icon" type="setting" />
              <span>{{ item.name }}</span>
            </span>
          </a-menu-item>
          <a-sub-menu v-if="item.children.length > 0" :key="item.url" :name="item.name">
            <span slot="title">
              <a-icon type="setting" />
              <span>{{ item.name }}</span>
            </span>
            <a-menu-item
              v-for="childItem in item.children"
              :key="item.url + '/' + (childItem.redirect || childItem.url)"
              :name="childItem.name"
            >
              <span>{{ childItem.name }}</span>
            </a-menu-item>
          </a-sub-menu>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <right-content v-if="token" />
      </a-layout-header>
      <a-layout-content style="margin: 0 10px">
        <keep-alive :include="[]">
          <router-view></router-view>
        </keep-alive>
      </a-layout-content>
    </a-layout>
    <div v-if="!isRenew" class="panel-renew flex column center">
      <div>
        您使用的服务将于
        <span style="color: red">0天</span>
        到期
      </div>
      <div>请前往客户端进行续费</div>
    </div>
  </a-layout>
</template>
<script>
  import RightContent from '@/components/global-header/right-content.vue'
  import route from '@/routes/route.js'
  import { getResourcesTree, getRetainDays, querySensitiveAuth } from 'apis/user'

  export default {
    components: {
      RightContent,
    },
    data() {
      return {
        isRenew: true,
        breadcrumb: [],
        collapsed: false,
        routerList: [],
        rootSubmenuKeys: [],
        openKeys: [],
        selectKeys: [],
        loadMenu: true,
        token: '',
      }
    },
    created() {
      const TOKEN = window.sessionStorage.getItem('token')
      if (TOKEN) {
        this.checkLogin()
        this.getAuth()
        this.getRetainDaysFn()
        // 获取订单编辑限制
        this.$store.dispatch('order/fetchOrderEditLimit')
      } else {
        this.handleLogout()
      }
    },
    watch: {
      $route(newVal, old) {
        this.selectKeys = [this.$route.path]
        if (newVal.path != '/purchase/addPurchaseInventory') {
          window.sessionStorage.removeItem('addPurchaseData')
        }
        if (newVal.path != '/warehouse/allocatinginvoice') {
          window.sessionStorage.removeItem('allocations')
        }
      },
    },
    methods: {
      async getRetainDaysFn() {
        let res = await getRetainDays()
        this.isRenew = res.retainDays
      },
      handleLogout(e) {
        this.$store.commit('setUserInfo', null)
        window.sessionStorage.removeItem('dictionaries')
        window.sessionStorage.removeItem('userInfo')
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('storageName')
        window.sessionStorage.removeItem('addPurchaseData')
        window.sessionStorage.removeItem('allocations')
        window.sessionStorage.removeItem('outboundPermission')
        window.sessionStorage.removeItem('ignorePermission')
        this.$router.push({ name: 'login' })
      },
      // 初始化路由
      async initRouter() {
        this.loadMenu = false
        getResourcesTree({ data: { appCode: 'saas_report' } }).then((res) => {
          res = res ?? []
          // res数组根据sort排序
          if (res.length > 0) {
            res.sort((a, b) => a.sort - b.sort)
          }
          this.setStoreList(this.filterRouter(res))
          let list = [],
            urlList = []
          const sider_list = route[0].children
          // 获取当前用户的tenantType
          const currentTenantType = JSON.parse(sessionStorage.getItem('userInfo'))?.tenantType
          console.log('当前用户tenantType:', currentTenantType)

          // 返回权限数组处理成平级数据
          sider_list.forEach((element) => {
            element.name = element.meta.title
            element.url = element.path
            element.children.forEach((item) => {
              item.name = item.meta.title
              item.url = item.path
              // 检查是否有tenantTypeFilter限制
              if (item.meta?.tenantTypeFilter && !item.meta.tenantTypeFilter.includes(+currentTenantType)) {
                return // 跳过不符合tenantType条件的路由
              }
              const copyItem = this.$utils.deepCopy(item)
              urlList.push(this.$utils.deepCopy(item))
            })
            const copyElement = this.$utils.deepCopy(element)
            urlList.push(copyElement)
          })
          res.forEach((item, index) => {
            let o = urlList.find((element) => {
              return item.code == element.key
            })
            if (o === undefined) return
            let copyO = this.$utils.deepCopy(o)
            copyO.children = []
            item.children
              .sort((a, b) => a.sort - b.sort)
              .forEach((element1) => {
                let o1 = o.children?.find((element) => {
                  return element1.code == element.key
                })
                if (o1 === undefined) return
                // 检查是否有tenantTypeFilter限制
                if (o1.meta?.tenantTypeFilter && !o1.meta.tenantTypeFilter.includes(+currentTenantType)) {
                  console.log(
                    '过滤路由:',
                    o1.key,
                    'tenantTypeFilter:',
                    o1.meta.tenantTypeFilter,
                    '当前tenantType:',
                    currentTenantType
                  )
                  return // 跳过不符合tenantType条件的路由
                }
                copyO.children.push(o1)
              })
            list.push(copyO)
          })
          list.forEach((item) => {
            item.url = item.path
            item.name = item.meta.title
            if (item.path === this.$route.path) {
              this.selectKeys = [item.path]
              this.openKeys = [item.path]
            }

            item.children.forEach((childrenItem) => {
              childrenItem.url = childrenItem.path
              childrenItem.name = childrenItem.meta.title
              if (item.path + '/' + (childrenItem.redirect || childrenItem.path) === this.$route.path) {
                this.selectKeys = [item.path + '/' + (childrenItem.redirect || childrenItem.url)]
                this.openKeys = [item.path]
              }
            })
          })
          let aKey = []
          list.forEach((item) => {
            if (item.children.length > 0) {
              aKey.push(item.url)
            }
          })
          this.rootSubmenuKeys = aKey
          this.routerList = list

          this.loadMenu = true
          // if (this.$route.path != '/' && !this.$store.getters.checkUserPurview(this.$route.path)) { // TODO 不兼容地址拼参数的情况
          //   this.$router.replace({ path: '/404' })
          // }
        })
      },
      async getAuth() {
        const res = await querySensitiveAuth()
        this.$store.commit('setAuth', res)
      },
      // 校验登陆
      checkLogin() {
        this.token = window.sessionStorage.getItem('token')
        if (!this.token) {
          this.$router.replace({ path: '/login' })
        } else {
          this.initRouter()
        }
      },
      // 取出全部树权限
      filterRouter(data) {
        let result = []
        if (!this.$utils.isArray(data)) return console.error('数据传入格式错误')
        data.forEach((element) => {
          let d = []
          if (element?.children?.length > 0) {
            d = this.filterRouter(element.children)
            result = result.concat(this.$utils.deepCopy(d))
          } else {
            result.push(element)
          }
        })
        return result
      },
      // 设置权限到store里
      setStoreList(data) {
        this.$store.commit('setListAllPerm', data)
      },
      // 打开子级弹窗
      onOpenChange(openKeys) {
        const latestOpenKey = openKeys.find((key) => this.openKeys.indexOf(key) === -1)
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : []
        }
      },
      /**
       * menu点击事件
       * @param e
       */
      menuClick(e) {
        if (e.key === this.$route.path) return
        this.$router.replace({ path: e.key })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .panel-renew {
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 999;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 32px;
  }

  #components-layout-demo-side .logo {
    width: 142px;
    height: auto;
    line-height: 32px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    /*background: rgba(255, 255, 255, 0.2);*/
    margin: 16px;
  }

  .sider_icon {
    width: 14px;
    vertical-align: baseline;
  }
</style>
<style lang="scss">
  #components-layout-demo-side .ant-menu-dark {
    height: calc(100vh - 140px);
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
